import React from 'react'
import { connect } from 'react-redux'
import FilesActions from '../Redux/FilesRedux'

class FileUploader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      file: null, // selected file before upload
      uploaded: false, // to state that the file is uploaded
      passed: false, // to make sure it pass the data once, cause UNSAFE_componentWillReceiveProps would trigger several times
      url: '', // grab url from successfully uploaded file
      uploading: false, // side effect: 'uploading ...' text
      err: null, // side effect: to contain error
      active: false // active flag for the component (uploadable = TRUE)
    }
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data && !this.state.passed && this.state.active) {
      this._passResult(newProps.files.data.upload[0].filename)
      this.setState({
        passed: true,
        url: newProps.files.data.upload[0].url,
        uploading: false,
        active: false
      })
    }
    if (newProps.files.err && !this.state.passed) {
      this.setState({ passed: true, err: newProps.files.err, file: null })
    }
  }

  _passResult = (filename) => {
    this.props.onUploaded(filename)
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
    this._upload(event)
  }

  _upload = (event) => {
    this.setState({ passed: false, uploading: true, active: true })
    let data = new FormData()
    const files = event.target.files[0] || this.state.file.files[0]
    data.append('files', files)

    const { setting } = this.props
    Object.keys(setting).map((key) => (
      data.append(key, setting[key])
    ))
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  render () {
    const date = Date.now()
    return (
      <div>
        <div className='input-group'>
          <div className='custom-file'>
            <input type='file' name='files' required={this.props.required} className='custom-file-input' onChange={(event) => this._fileSelect(event)} />
            <label className='custom-file-label'>
              {this.state.file ? 'File selected' : 'Choose files'}
            </label>
          </div>
        </div>
        { this.state.uploading && 'Uploading ...' }
        {
          this.state.uploaded && !this.state.uploading
            ? <div>
              {this.state.url &&
              <img alt={this.state.url} className='img img-responsive' src={this.state.url + '?v=' + date} style={{ maxWidth: '100%' }} />
              }
            </div>
            : <div>
            No Files Uploaded
            </div>
        }
        {
          this.state.err &&
          <div className='alert alert-danger'>
            { this.state.err }
          </div>
        }
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FileUploader)



// WEBPACK FOOTER //
// ./src/Containers/FileUploader.js